import { render, staticRenderFns } from "./ListPropertyPage.vue?vue&type=template&id=f5671c4c"
import script from "./ListPropertyPage.vue?vue&type=script&lang=js"
export * from "./ListPropertyPage.vue?vue&type=script&lang=js"
import style0 from "./ListPropertyPage.vue?vue&type=style&index=0&id=f5671c4c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports